import { useMutation } from '@tanstack/react-query';

import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { queryClient } from '@/lib/react-query';
import useToasts from '@/shared/hooks/useToasts';
import { MessageType } from '@/shared/hooks/useToasts.types';

const dissociatePartner =
  (makeRequest: ReturnType<typeof useImperativeRequestWrapper>[1]) =>
  async (partnerId: string) => {
    const { error, data } = await makeRequest({
      path: `/admin/partners/${partnerId}/parent`,
      method: 'delete',
    });

    if (error) {
      throw new Error(
        typeof error === 'string' ? error : (error?.message ?? 'Unknown error')
      );
    }

    return data;
  };

export const useDeleteDissociatePartner = () => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillage');
  const addError = useError();
  const addSuccessMsg = useToasts((state) => state.addItem);

  return useMutation({
    onError: () => {
      addError('Failed to unlink partner');
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['partner-hierarchy'],
      });
      queryClient.refetchQueries({
        queryKey: ['partner-v3'],
      });

      addSuccessMsg(
        {
          msg: 'Organization was successfully unlinked!',
          type: MessageType.Success,
        },
        'root',
        {}
      );
    },
    mutationFn: dissociatePartner(makeRequest),
  });
};
